import { inject } from '@angular/core';
import { environment } from '../environments/environment';
import { KeycloakService } from './services/keycloak.service';

export function initializeKeycloak(): Promise<boolean> {
  const keycloak = inject(KeycloakService);

  return keycloak.init(
    {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId,
    },
    {
      onLoad: 'check-sso',
      checkLoginIframe: false,
      pkceMethod: 'S256',
    },
  );
}
